import moment from 'moment';
import Swal from 'sweetalert2';
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'BranchAddWizard',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        const allowed = this.isAdministratorRole() || this.isMinistryUserRole();
        if (!this.loginDetails || !allowed) {
            this.logout();
            return;
        }
        await this.loadFormularyCategories();
        await this.loadPickerGrid(1);
    },

    data() {
        return {
            wizardStep: 0,
            wizardSteps: [
                { title: 'بيانات المرفق', subtitle: 'الاسم والوصف', icon: 'ti-building-hospital' },
                { title: 'رئيس المصحة', subtitle: 'حساب المدير', icon: 'ti-user-shield' },
                { title: 'القائمة النمطية', subtitle: 'اختياري — يمكن إنشاء المرفق بدون أصناف', icon: 'ti-pill' },
            ],
            branchForm: {
                name: '',
                descriptions: '',
            },
            managerForm: {
                name: '',
                loginName: '',
                phone: '',
                email: '',
            },
            branchRules: {
                name: this.$helper.Required(),
            },
            managerRules: {
                name: this.$helper.Required(),
                loginName: this.$helper.Required(),
                phone: this.$helper.Required(),
            },
            formularyCategories: [],
            pickerSearch: '',
            pickerPageNo: 1,
            pickerPageSize: 25,
            pickerPages: 0,
            pickerRows: [],
            pickerFilterCategoryId: '',
            pickerDescriptionSearch: '',
            pickerCodePrefix: '',
            pickerCodeRangeFrom: '',
            pickerCodeRangeTo: '',
            pickerBulkCodesPaste: '',
            pickerPendingExcelFile: null,
            pickerResolveBusy: false,
            pickerLastResolveUnknown: [],
            selectedNationalIds: [],
            pickerLoadError: '',
        };
    },

    computed: {
        pickerTableMaxHeight() {
            if (typeof window === 'undefined' || !window.innerHeight) return 520;
            return Math.max(380, Math.min(920, Math.round(window.innerHeight * 0.58)));
        },
    },

    methods: {
        goBackToList() {
            this.$router.push({ path: '/Branches' });
        },

        isStepActive(i) {
            return this.wizardStep === i;
        },
        isStepDone(i) {
            return this.wizardStep > i;
        },

        async loadFormularyCategories() {
            try {
                const res = await this.$http.GetBranchNationalFormularyCategories();
                this.formularyCategories = res.data || [];
            } catch (err) {
                this.formularyCategories = [];
                const msg = (err && err.response && err.response.data) || 'تعذر تحميل التصنيفات الطبية.';
                this.$helper.ShowMessage('warning', 'تنبيه', msg);
            }
        },

        buildPickerFilters() {
            const f = {};
            if (this.pickerFilterCategoryId !== '' && this.pickerFilterCategoryId != null) {
                const n = Number(this.pickerFilterCategoryId);
                if (!Number.isNaN(n) && n > 0) f.categoryId = n;
            }
            const desc = (this.pickerDescriptionSearch || '').trim();
            if (desc) f.descriptionSearch = desc;
            const rFrom = (this.pickerCodeRangeFrom || '').trim();
            const rTo = (this.pickerCodeRangeTo || '').trim();
            const prefix = (this.pickerCodePrefix || '').trim();
            if (rFrom && rTo) {
                f.codeFrom = rFrom;
                f.codeTo = rTo;
            } else if (prefix) {
                f.codePrefix = prefix;
                if (rFrom) f.codeFrom = rFrom;
                if (rTo) f.codeTo = rTo;
            } else {
                if (rFrom) f.codeFrom = rFrom;
                if (rTo) f.codeTo = rTo;
            }
            return f;
        },

        clearPickerFilters() {
            this.pickerSearch = '';
            this.pickerFilterCategoryId = '';
            this.pickerDescriptionSearch = '';
            this.pickerCodePrefix = '';
            this.pickerCodeRangeFrom = '';
            this.pickerCodeRangeTo = '';
            this.loadPickerGrid(1);
        },

        mergePickerResolvedIds(matchList) {
            const set = new Set(this.selectedNationalIds || []);
            let added = 0;
            (matchList || []).forEach((m) => {
                const id = m && m.id != null ? m.id : null;
                if (id == null) return;
                if (!set.has(id)) {
                    set.add(id);
                    added += 1;
                }
            });
            this.selectedNationalIds = Array.from(set);
            this.$nextTick(() => this.syncPickerTableSelection());
            return added;
        },

        async pickerResolvePastedCodes() {
            const raw = (this.pickerBulkCodesPaste || '').split(/\r?\n/).map((s) => s.trim()).filter(Boolean);
            if (!raw.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'الصق سطراً واحداً على الأقل يحتوي على كود.');
                return;
            }
            this.pickerResolveBusy = true;
            try {
                const res = await this.$http.ResolveBranchNationalFormularyCodes(raw, null);
                const matches = (res.data && res.data.matches) || [];
                this.pickerLastResolveUnknown = (res.data && res.data.unknownCodes) || [];
                const added = this.mergePickerResolvedIds(matches);
                this.$helper.ShowMessage('success', 'تمت المطابقة', `أضيف ${added} بنداً جديداً إلى الاختيار (${matches.length} مطابَقاً من الأكواد المرسلة).`);
            } catch (e) {
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    e.message ||
                    'تعذّرت المطابقة.';
                this.$helper.ShowMessage('error', 'خطأ', typeof msg === 'string' ? msg : 'تعذّرت المطابقة.');
            } finally {
                this.pickerResolveBusy = false;
            }
        },

        onPickerExcelFileChange(ev) {
            const f = ev.target.files && ev.target.files[0];
            this.pickerPendingExcelFile = f || null;
        },

        async pickerResolveExcelFile() {
            if (!this.pickerPendingExcelFile) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر ملف Excel أولاً.');
                return;
            }
            this.pickerResolveBusy = true;
            try {
                const res = await this.$http.ResolveBranchNationalFormularyCodesExcel(this.pickerPendingExcelFile, null);
                const matches = (res.data && res.data.matches) || [];
                this.pickerLastResolveUnknown = (res.data && res.data.unknownCodes) || [];
                const added = this.mergePickerResolvedIds(matches);
                this.$helper.ShowMessage('success', 'تمت قراءة الملف', `أضيف ${added} بنداً جديداً إلى الاختيار (${matches.length} مطابَقاً).`);
                this.pickerPendingExcelFile = null;
                const inp = this.$refs.pickerExcelInput;
                if (inp) inp.value = '';
            } catch (e) {
                const msg =
                    (e.response && e.response.data && (e.response.data.message || e.response.data)) ||
                    e.message ||
                    'تعذّرت قراءة الملف.';
                this.$helper.ShowMessage('error', 'خطأ', typeof msg === 'string' ? msg : 'تعذّرت قراءة الملف.');
            } finally {
                this.pickerResolveBusy = false;
            }
        },

        async loadPickerGrid(page) {
            if (page != null && page !== '') this.pickerPageNo = page;
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetBranchNationalFormularyNationalPickerGrid(
                    this.pickerPageNo,
                    this.pickerPageSize,
                    this.pickerSearch,
                    this.buildPickerFilters()
                );
                this.pickerRows = (res.data && res.data.info) ? res.data.info : [];
                this.pickerPages = res.data && res.data.count != null ? res.data.count : 0;
                this.pickerLoadError = '';
            } catch (err) {
                this.pickerRows = [];
                this.pickerPages = 0;
                const msg = (err && err.response && err.response.data) || 'تعذر تحميل القائمة النمطية. تحقق من الجلسة وبيانات السجل ثم أعد المحاولة.';
                this.pickerLoadError = typeof msg === 'string' ? msg : 'تعذر تحميل القائمة النمطية.';
                this.$helper.ShowMessage('error', 'تعذر تحميل القائمة النمطية', this.pickerLoadError);
            } finally {
                this.$blockUI.Stop();
            }
        },

        onPickerSelectionChange(rows) {
            this.selectedNationalIds = (rows || []).map((r) => r.id);
        },

        nextStep() {
            if (this.wizardStep === 0) {
                this.$refs.branchStepForm.validate((valid) => {
                    if (!valid) {
                        this.$helper.showSwal('warning');
                        return;
                    }
                    this.wizardStep += 1;
                });
                return;
            }
            if (this.wizardStep === 1) {
                this.$refs.managerStepForm.validate((valid) => {
                    if (!valid) {
                        this.$helper.showSwal('warning');
                        return;
                    }
                    this.wizardStep += 1;
                    this.$nextTick(() => this.syncPickerTableSelection());
                });
                return;
            }
        },

        prevStep() {
            if (this.wizardStep > 0) this.wizardStep -= 1;
        },

        syncPickerTableSelection() {
            const tb = this.$refs.pickerTable;
            if (!tb) return;
            if (typeof tb.doLayout === 'function') tb.doLayout();
            if (!this.pickerRows || !this.pickerRows.length) return;
            tb.clearSelection();
            this.pickerRows.forEach((row) => {
                if (this.selectedNationalIds.includes(row.id)) {
                    tb.toggleRowSelection(row, true);
                }
            });
        },

        async submitWizard() {
            const body = {
                name: this.branchForm.name.trim(),
                descriptions: (this.branchForm.descriptions || '').trim(),
                managerName: this.managerForm.name.trim(),
                managerLoginName: this.managerForm.loginName.trim(),
                managerPhone: this.managerForm.phone.trim(),
                managerEmail: (this.managerForm.email || '').trim(),
                nationalFormularyItemIds: this.selectedNationalIds.slice(),
            };
            this.$blockUI.Start();
            try {
                const res = await this.$http.AddBranchWizard(body);
                this.$blockUI.Stop();
                const pwd = res.data && res.data.generatedPassword;
                const bid = res.data && res.data.branchId;
                await Swal.fire({
                    title: 'تم إنشاء المرفق',
                    html: pwd
                        ? `<p class="mb-2">${res.data.message || 'تمت العملية بنجاح.'}</p><p class="text-start small">معرّف المرفق: <strong>${bid}</strong></p><p class="text-start small text-danger">احفظ كلمة مرور رئيس المصحة وسلّمها له بأمان:</p><p class="fw-bold text-center dir-ltr user-select-all">${pwd}</p>`
                        : (res.data && res.data.message) || 'تمت العملية بنجاح.',
                    icon: 'success',
                    confirmButtonText: 'العودة للمرافق',
                    customClass: { confirmButton: 'btn btn-primary' },
                    buttonsStyling: false,
                });
                this.$router.push({ path: '/Branches' });
            } catch (err) {
                this.$blockUI.Stop();
                let msg = 'تعذر إكمال الإضافة.';
                if (err && err.response) {
                    const data = err.response.data;
                    if (typeof data === 'string' && data.length) {
                        msg = data;
                    } else if (data && typeof data === 'object' && data.message) {
                        msg = data.message;
                    } else if (err.response.status === 401 || err.response.status === 403) {
                        msg = 'انتهت الجلسة أو لا توجد صلاحية. سجّل الدخول مجدداً ثم أعد المحاولة.';
                    } else if (err.response.status === 404) {
                        msg = 'تعذر الوصول إلى نقطة النهاية (404). أعد تشغيل الخادم بعد تحديث الواجهة وأعد تحميل الصفحة.';
                    } else if (err.response.status >= 500) {
                        msg = 'خطأ في الخادم أثناء الحفظ. راجع سجل الخادم لمزيد من التفاصيل.';
                    }
                } else if (err && err.message) {
                    msg = err.message;
                }
                this.$helper.ShowMessage('error', 'خطأ', msg);
            }
        },
    },

    watch: {
        wizardStep(val) {
            if (val === 2) {
                this.$nextTick(() => this.syncPickerTableSelection());
            }
        },
    },

    filters: {
        moment(date) {
            if (!date) return '—';
            return moment(date).format('DD/MM/YYYY');
        },
    },
};
